import { Arg, MODAL_ARGS, Metadata, pick } from '../../../utils/spds/metadata';
import {
  MODAL_DOCS_FLYOUT_BLOCKS,
  assembleModalDescription,
} from '../../../utils/spds/metadata/modal-docs';
import { hash } from '@ember/helper';
import Body from './flyout/body.gjs';
import FlexColumn from '../layout/flex/column.gjs';
import Footer from './flyout/footer.gjs';
import Header from './flyout/header.gjs';
import Super from '../core/modal.gjs';
import styles from './flyout.module.scss';

const DEFAULT_SIZE = 'small';
const ALLOWED_SIZES = [DEFAULT_SIZE, 'large'];

const METADATA = Metadata.define({
  description: assembleModalDescription(
    `Panel that slides in from the side for viewing or editing.
Defaults to close on click outside.
Flyouts can either be a \`modal\` or \`popover\` and either \`small\` or \`large\` in size. See the [design and content guidelines](https://www.simplepractice.design/1d0abbc0a/p/4652d6-flyouts/b/18a849) for details.`,
    MODAL_DOCS_FLYOUT_BLOCKS
  ),
  extends: [pick(MODAL_ARGS, [{ name: 'closeOnClickOutside', default: true }])],
  meta: {
    modal: Arg.boolean({
      description: 'When true, renders as a modal dialog with backdrop',
    }),
    size: Arg.string({
      default: DEFAULT_SIZE,
      description: 'Width of the flyout',
      options: ALLOWED_SIZES,
    }),
  },
  name: 'Flyout',
});

export default class SpdsModalFlyout extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-flyout';
  classesToMapToAttrs = ['isVisible', 'modal', 'sizing'];
  defaultSize = DEFAULT_SIZE;
  sizes = ALLOWED_SIZES;
  styles = styles;

  get bodyId() {
    return this.composeSubcomponentId('body');
  }

  get footerId() {
    return this.composeSubcomponentId('footer');
  }

  get headerId() {
    return this.composeSubcomponentId('header');
  }

  get modal() {
    return this.argOrDefault('modal');
  }

  get sizing() {
    return this.argOrDefault('size');
  }

  <template>
    <FlexColumn
      @fixed={{true}}
      @id={{this.id}}
      @tag="dialog"
      class={{this.classes}}
      data-test-spds-modal-flyout
      ...attributes
      {{this.setupComponent}}
      {{this.validateArguments}}
    >
      <FlexColumn @flex="1" class="spds-modal-flyout-inner" data-test-spds-modal-flyout-inner>
        {{yield
          (hash
            Header=(component Header close=this.beforeClose id=this.headerId)
            Body=(component Body id=this.bodyId)
            Footer=(component Footer id=this.footerId)
            beforeClose=this.beforeClose
            close=this.close
          )
        }}
      </FlexColumn>
    </FlexColumn>
  </template>
}

export const MODAL_FLYOUT_METADATA = SpdsModalFlyout.metadata;
